var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPension = function SvgPension(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.5,
    height: 21.74
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3583",
    d: "M4.802 12.932v7.725h15.385v-6.738",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3584",
    d: "M3.285 10.21 12.495 1l7.546 7.35",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 366",
    d: "M1 20.74h27"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 367",
    d: "M24 19.74v-4.52"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 481",
    transform: "translate(18.5 5.24)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8919",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 339",
    d: "M14.75 14.49v-3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 340",
    d: "M17 11.49h-2.25"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8920",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 339",
    d: "M8.75 14.49v-3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 340",
    d: "M11 11.49H8.75"
  })))));
};
export default SvgPension;